<template>
	<span class="svgToPngContainer">
		<span class="badge badge-secondary pointer" style="background-color:#CACACA" @click="download()">download
		</span>
	</span>
</template>
<script>
import * as d3 from "d3"
import { mapGetters } from 'vuex'
	
export default {
	name: 'SvgToPng',
	components: { },
	props: ['svg_id','container_id','isc3','title'],
	data () {
		return {	}
	},
	computed:{
		...mapGetters({
			dataset: "dataset",
			parameters: "parameters",
			analysis: "analysis"
		}),
		prefix(){
			let pre = this.parameters.dataset_name;
			if (this.analysis && this.analysis.analysis_name){
				pre += '_'+this.analysis.analysis_name ;
			}
			return pre + '_';
		}
	},
	methods: {
		
		download(){
			var svg_obj;
			if (this.svg_id){
				svg_obj = d3.select("#"+this.svg_id).node();
			}
			else{
				let obj = document.getElementById(this.container_id);
				svg_obj = obj.getElementsByTagName("svg")[0];
				console.info(obj,svg_obj);
			}
			if (!svg_obj){
				// console.info("svg object doesn't exist");
				return;
			}

			if (this.isc3){
				if ((this.container_id && !this.container_id.startsWith('gene_plot_1p') && !this.container_id.startsWith('protein_count'))){
					var nodeList = svg_obj.querySelectorAll('.c3-chart path');
					var line_graph = Array.from(nodeList);
					line_graph.forEach(function(element){ element.style.fill = "none"; })
				}
				var nodeList3 = svg_obj.querySelectorAll('.c3 line');
				var nodeList2 = svg_obj.querySelectorAll('.c3-axis path');
				var x_and_y = Array.from(nodeList2).concat(Array.from(nodeList3));
				x_and_y.forEach(function(element){ element.style.fill = "none"; element.style.stroke = "black"; })
			}
								
			var svgString = this.getSVGString(svg_obj);
			this.svgToPng(svgString, svg_obj.clientWidth, svg_obj.clientHeight, this.title); // passes Blob and filesize String to the callback
		},
		
		getSVGString( svgNode ) {
			svgNode.setAttribute('xlink', 'http://www.w3.org/1999/xlink');
			var cssStyleText = getCSSStyles( svgNode );
			appendCSS( cssStyleText, svgNode );

			var serializer = new XMLSerializer();
			var svgString = serializer.serializeToString(svgNode);
			svgString = svgString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace
			svgString = svgString.replace(/NS\d+:href/g, 'xlink:href'); // Safari NS namespace fix

			return svgString;

			function getCSSStyles( parentElement ) {
				var selectorTextArr = [];
				let c, i, r
				// Add Parent element Id and Classes to the list
				selectorTextArr.push( '#'+parentElement.id );
				for (c = 0; c < parentElement.classList.length; c++)
					if ( !contains('.'+parentElement.classList[c], selectorTextArr) )
						selectorTextArr.push( '.'+parentElement.classList[c] );

				// Add Children element Ids and Classes to the list
				var nodes = parentElement.getElementsByTagName("*");
				for (i = 0; i < nodes.length; i++) {
					var id = nodes[i].id;
					if ( !contains('#'+id, selectorTextArr) )
						selectorTextArr.push( '#'+id );

					var classes = nodes[i].classList;
					for ( c = 0; c < classes.length; c++)
						if ( !contains('.'+classes[c], selectorTextArr) )
							selectorTextArr.push( '.'+classes[c] );
				}

				// Extract CSS Rules
				var extractedCSSText = "";
				for (i = 0; i < document.styleSheets.length; i++) {
					var s = document.styleSheets[i];
			
					try {
						if (!s.cssRules) continue;
					} catch( e ) {
						if (e.name !== 'SecurityError') throw e; // for Firefox
						continue;
					}

					var cssRules = s.cssRules;
					for (r = 0; r < cssRules.length; r++) {
						if ( contains( cssRules[r].selectorText, selectorTextArr ) )
							extractedCSSText += cssRules[r].cssText;
					}
				}
		
				return extractedCSSText;

				function contains(str,arr) {
					return arr.indexOf( str ) === -1 ? false : true;
				}
			}

			function appendCSS( cssText, element ) {
				var styleElement = document.createElement("style");
				styleElement.setAttribute("type","text/css"); 
				styleElement.innerHTML = cssText;
				var refNode = element.hasChildNodes() ? element.children[0] : null;
				element.insertBefore( styleElement, refNode );
			}
		},
		
		svgToPng(svgString,width,height,title){
			var _this = this;
			svgString2Image( svgString, width, height, save ); // passes Blob and filesize String to the callback

			function save( dataBlob ){
				window.saveAs(dataBlob, _this.prefix+title+'.png' ); // FileSaver.js function
			}
				
			function svgString2Image( svgString, width, height, callback ) {
				var imgsrc = 'data:image/svg+xml;base64,'+ btoa( unescape( encodeURIComponent( svgString ) ) ); // Convert SVG string to data URL

				var canvas = document.createElement("canvas");
				var context = canvas.getContext("2d");

				canvas.width = width;
				canvas.height = height;

				var image = new Image();
				image.onload = function() {
					context.clearRect ( 0, 0, width, height );
					context.drawImage(image, 0, 0, width, height);

					canvas.toBlob( function(blob) {
						var filesize = Math.round( blob.length/1024 ) + ' KB';
						if ( callback ) callback( blob, filesize );
					});
				};
				image.src = imgsrc;
			}
		},

	
	}

}
</script>
<style scoped>

</style>